import { Component } from '@angular/core';

@Component({
    selector: 'app-organization',
    imports: [],
    templateUrl: './organization.component.html',
    styleUrl: './organization.component.css'
})
export class OrganizationComponent {

}
